export const GRAPHQL_VARIABLES = {
  customerId: null,
  event: '',
  attr: {}
};

export const QUERY = `
   mutation customersLogEvent($customerId: MongoID!, $event: String!, $attr: JSON) {
      customersLogEvent(customerId: $customerId, event: $event, attr: $attr) {
        message
      }
   }
`;
